import { Component, OnInit } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { TableItem } from '../../models/table';
import { TableService } from '../../services/table.service';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';

interface SkillResponse {
  skill_id: number;
  skill_name: string;
  skill_description: string;
  skill_group_id: number;
  g_name: string;
}

@Component({
  selector: 'app-skillteam',
  standalone: true,
  imports: [PrimeTemplate, TableModule, FormsModule],
  templateUrl: './skillteam.component.html',
  styleUrl: './skillteam.component.scss',
})
export class SkillteamComponent implements OnInit {
  skillsNames: string[] = [];
  skills: SkillResponse[] = [];

  teams: string[] = [];

  data: TableItem[] = [];

  groups: string[] = [];

  constructor(
    private tableService: TableService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.tableService.getSkills().subscribe(skills => {
      this.skills = skills.map(skill => ({
        ...skill,
      }));

      this.apiService.getTeamsWithSkills().subscribe(teamSkillData => {
        this.teams = teamSkillData
          .map(team => team.name)
          .sort((a, b) => a.localeCompare(b));

        const skillTeamMap = new Map<string, Set<string>>();
        for (const team of teamSkillData) {
          for (const skill of team.skills) {
            if (!skillTeamMap.has(skill.name)) {
              skillTeamMap.set(skill.name, new Set());
            }
            skillTeamMap.get(skill.name)!.add(team.name);
          }
        }

        this.skills = this.skills.map(skill => {
          const result: any = {
            ...skill,
          };
          let usedByCount = 0;
          for (const teamName of this.teams) {
            const isUsed = skillTeamMap.get(skill.skill_name)?.has(teamName) ?? false;
            result[teamName] = isUsed;
            if (isUsed) usedByCount++;
          }
          result.usedByCount = usedByCount;
          return result;
        });
      });
    });
  }

  onSkillToggle(skillRow: any, teamName: string, checked: boolean) {
    const skillName = skillRow.skill_name;

    skillRow[teamName] = checked;

    // Aggiorna il contatore locale
    if (checked) {
      skillRow.usedByCount++;
    } else {
      skillRow.usedByCount--;
    }

    // Mantieni la logica esistente per la chiamata API
    this.apiService.getTeamsWithSkills().subscribe(teamSkillData => {
      const team = teamSkillData.find(t => t.name === teamName);
      const currentSkills = team?.skills.map(s => s.name) || [];

      const updatedSkills = checked
        ? [...currentSkills, skillName]
        : currentSkills.filter(name => name !== skillName);

      this.apiService.updateSkillsForTeam(teamName, updatedSkills).subscribe({
        next: () => console.log(`Updated skills for ${teamName}`),
        error: err => console.error(`Error updating skills:`, err),
      });
    });
  }

  getChecked(event: Event): boolean {
    return (event.target as HTMLInputElement)?.checked ?? false;
  }
}
